module.exports = __webpack_public_path__ + "img/right_alignment.70eaf0ce.svg";